import React, { useContext, useEffect, useState } from "react";
import { MdKeyboardArrowLeft } from "react-icons/md";
import InputField from "../../../../components/inputField/InputField";
import AppContext from "../../../../context/app-context";
import SelectInput from "../../../../components/selectInput/SelectInput";
import "./Transfer.css";
import { formatToMoney } from "../../../../utils";
import { fetchApi } from "../../../../api";
import Button from "../../../../components/button/Button";
import { FaUser, FaWallet } from "react-icons/fa";
import { popup } from "../../../../vanilla-functions/model";
import RefundCode from "../refund/refund-code";

type Props = {
  onClickBack?: () => void;
};

export const Transfer = (props: Props) => {
  const { onClickBack } = props;

  const { setIsLoading, estates } = useContext(AppContext);

  const [estate, setEstate] = useState<any>();
  const [users, setUsers] = useState<any[]>([]);
  const [narration, setNarration] = useState<string>("");
  const [title, setTitle] = useState<string>("");
  const [amount, setAmount] = useState("");
  const [fromUser, setFromUser] = useState<any>("");
  const [toUser, setToUser] = useState<any>("");
  const [openCodeModal, setOpenCodeModal] = useState(true)


  const getUsers = async () => {
    try {
      if (!estate?.backend_base_url || !estate?.estate_id) return;
      setIsLoading?.(true);
      const url = `${estate?.backend_base_url}/user/get?estateID=${estate?.estate_id}`;
      const { data } = await fetchApi({ url, method: "GET" });
      setIsLoading?.(false);
      setUsers(data?.data || []);
      console.log(data?.data[0]);
    } catch (error) {
      setIsLoading?.(false);
    }
  };

  useEffect(() => {
    (async () => {
      setUsers([])
      try {
        if (!estate?.backend_base_url || !estate?.estate_id) return;
        setIsLoading?.(true);
        const url = `${estate?.backend_base_url}/user/get?estateID=${estate?.estate_id}`;
        const { data } = await fetchApi({ url, method: "GET" });
        setIsLoading?.(false);
        setUsers(data?.data || []);
        console.log(data?.data[0]);
      } catch (error) {
        setIsLoading?.(false);
      }
    })();
  }, [estate, setIsLoading]);

  const handleTransfer = async () => {
    if (!estate?.backend_base_url || !estate?.estate_id) return;
    try {
      const input = window.prompt("Kindly Supply passkey", "");
      if (input !== "EST424") return;
      const url = `${estate?.backend_base_url}/transfer`;

      const payload = {
        userToCharge: fromUser?._id,
        userToCredit: toUser?._id,
        amount: amount,
        transactionTitle: narration,
        narration: narration,
        otp: "",
      };
      setIsLoading?.(true);
      const { data, hasError } = await fetchApi({
        url,
        method: "POST",
        body: payload,
      });
      setIsLoading?.(false);
      popup(data?.message || data?.status);
      if (!hasError) {
        setFromUser(null);
        setToUser(null);
        setAmount("");
        setNarration("");
        setTitle("");
        getUsers();
      }
    } catch (error: any) {
      popup(error?.message);
      setIsLoading?.(false);
    }
  };

  const disable =
    parseFloat(fromUser?.wallet?.balance || "0") < parseFloat(amount) ||
    !toUser ||
    !fromUser ||
    !estate ||
    !amount ||
    parseFloat(amount) <= 0;

    const sendCode = async (code: string) => {
      console.log(code)
    }

  return (
    <div>
      <div className="uh-container">
        <div className="financemgt-back-btn" onClick={() => onClickBack?.()}>
          <MdKeyboardArrowLeft size={25} />
          Back{" "}
        </div>
        <div className="estate-incentive-label">Wallet Transfer - Finance</div>
        <SelectInput
          name="estateName"
          options={estates}
          keyToRender="estate_name"
          keyValue="estate_id"
          placeholder="Select an estate"
          value={estate?.estate_name}
          onChange={(e) => {
            const val = estates?.find(
              (j: any) => j?.estate_id === e?.target?.value
            );
            val && setEstate(val);
            setFromUser(null);
            setToUser(null);
            setAmount("");
          }}
        />

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "4px",
            gap: "0.7rem",
          }}
        >
          <SelectInput
            name="from"
            options={users}
            keyToRender="email"
            keyValue="_id"
            label="From:"
            placeholder="User to be debited"
            labelType="nested"
            value={`${fromUser?.first_name || ""} ${
              fromUser?.last_name || ""
            } ${fromUser?.email ? ` (${fromUser?.email})` : ""}`}
            onChange={(e) => {
              const usr = users?.find((j) => j?._id === e.target?.value);
              if (!usr) return;
              setFromUser(usr);
            }}
          />
          <SelectInput
            name="toUser"
            options={users}
            keyToRender="email"
            keyValue="_id"
            label="To:"
            placeholder="Select User to be credited"
            labelType="nested"
            value={`${toUser?.first_name || ""} ${toUser?.last_name || ""} ${
              toUser?.email ? `(${toUser?.email})` : ""
            }`}
            onChange={(e) => {
              const usr = users?.find((j) => j?._id === e.target?.value);
              if (!usr) return;
              setToUser(usr);
            }}
          />
        </div>

        {fromUser && (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: "1rem",
              padding: "5px",
              backgroundColor: "rgba(0,0,0,0.05)",
              borderRadius: "5px",
            }}
          >
            From:
            <FaUser />
            {fromUser?.first_name} {fromUser?.last_name}
            {"    -   "}
            <FaWallet />
            NGN {formatToMoney(fromUser?.wallet?.balance || "0")}
          </div>
        )}
        {toUser && (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: "1rem",
              padding: "5px",
              backgroundColor: "rgba(0,0,0,0.05)",
              borderRadius: "5px",
            }}
          >
            To:
            <FaUser />
            {toUser?.first_name} {toUser?.last_name}
            {"    -   "}
            <FaWallet />
            NGN {formatToMoney(toUser?.wallet?.balance || "0")}
          </div>
        )}

        {fromUser && toUser && (
          <>
            <InputField
              label="Amount To Transfer"
              labelType="nested"
              name="amount"
              value={amount}
              formatValue="number"
              onChange={(e) => {
                const str = e.target.value;
                setAmount(str);
              }}
            />
            {parseFloat(fromUser?.wallet?.balance || "0") <
              parseFloat(amount) && (
              <i style={{ color: "red", fontSize: "12px" }}>
                Insufficient fund
              </i>
            )}
          </>
        )}
        {fromUser && toUser && (
          <>
            <InputField
              label="Transaction Title"
              labelType="nested"
              name="title"
              value={title}
              onChange={(e) => {
                const str = e.target.value;
                setTitle(str);
              }}
            />
          </>
        )}
        {fromUser && toUser && (
          <>
            <InputField
              label="Narration"
              labelType="nested"
              name="narration"
              value={narration}
              onChange={(e) => {
                const str = e.target.value;
                setNarration(str);
              }}
            />
          </>
        )}

        {!disable && (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: "1rem",
              padding: "5px",
              backgroundColor: "rgba(0,0,0,0.05)",
              borderRadius: "5px",
            }}
          >
            Transfer NGN{formatToMoney(amount || "0")} to <FaUser />
            {toUser?.first_name} {toUser?.last_name}
          </div>
        )}

        <Button
          label="Transfer"
          disable={disable}
          onClick={() => handleTransfer()}
        />
      </div>
      <RefundCode onClickBack={onClickBack} isOpen={openCodeModal} setIsOpen={setOpenCodeModal} onClick={sendCode} showSuccess={sendCode} />

    </div>
  );
};
